import React from 'react';

import _snakeCase from 'lodash/snakeCase';

import { getGoogleLocationProviderSetting } from 'components/modules/business-profile/services/provider-service';
import { multiCaseGet } from 'libs/format';
import { capitalizeAll } from 'libs/strings';

export function getLocationSyncSettings(locationSettings = [], location) {
  const setting = getGoogleLocationProviderSetting(locationSettings, location);
  return multiCaseGet(setting, 'serviceData.settings') || {};
}

export function getDisplaySyncSetting(settingName, brandName) {
  const CUSTOM_DISPLAY_BY_NAME = {
    hours: 'Operating Hours',
    menu: 'Food Menu',
    website: `${brandName} Website URL`,
    title: 'Location Name',
    profile: 'Profile Description',
    services: 'Services',
  };

  let displayName = CUSTOM_DISPLAY_BY_NAME[settingName];

  if (displayName) {
    return displayName;
  }

  displayName = _snakeCase(settingName);
  displayName = displayName.replace('_', ' ');
  displayName = capitalizeAll(displayName);

  return displayName;
}

export function getPushHelpTooltip(settingName, brandName, menuLabel) {
  const CUSTOM_PUSH_HELP_TOOLTIP = {
    hours:
      'When enabled we will push updates to your Operating Hours to Google when you publish your site.',
    services: (
      <>
        <p>
          <strong>All Items:</strong> Use this to push your entire catalog to Google, regardless of
          whether it&apos;s tied to this location or any location at all.
        </p>
        <p>
          <strong>Only Associated Items:</strong> Best for locations with tightly controlled
          offerings.
        </p>
        <p>
          <strong>Associated + Unassigned Items:</strong> Ideal if you have general
          services/products not tied to a location but still want them listed.
        </p>
      </>
    ),
  };

  const customPushHelpTooltip = CUSTOM_PUSH_HELP_TOOLTIP[settingName];

  if (customPushHelpTooltip) {
    return customPushHelpTooltip;
  }

  const displayName = getDisplaySyncSetting(settingName, brandName, menuLabel);
  return `When enabled we will automatically push your ${displayName} to Google when you publish your site.`;
}

export function getPullHelpTooltip(settingName, brandName, menuLabel) {
  const CUSTOM_PULL_HELP_TOOLTIP = {};

  const customPullHelpTooltip = CUSTOM_PULL_HELP_TOOLTIP[settingName];

  if (customPullHelpTooltip) {
    return customPullHelpTooltip;
  }

  const displayName = getDisplaySyncSetting(settingName, brandName, menuLabel);
  return `When enabled we will automatically pull your ${displayName} from Google.`;
}
